module.exports = __webpack_public_path__ + "static/img/Mobile.1fdcbd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/Mobile.svg
// module id = 704
// module chunks = 1